export const appAccessControlConstants = {
    USERS_REQUEST: 'APP_ACCESS_CONTROL_USERS_REQUEST',
    USERS_SUCCESS: 'APP_ACCESS_CONTROL_USERS_SUCCESS',
    USERS_FAILURE: 'APP_ACCESS_CONTROL_USERS_FAILURE',
    ADD_USER_REQUEST: 'APP_ACCESS_CONTROL_ADD_USER_REQUEST',
    ADD_USER_SUCCESS: 'APP_ACCESS_CONTROL_ADD_USER_SUCCESS',
    ADD_USER_FAILURE: 'APP_ACCESS_CONTROL_ADD_USER_FAILURE',
    ACCESS_GRANT_REQUEST: 'APP_ACCESS_CONTROL_ACCESS_GRANT_REQUEST',
    ACCESS_GRANT_SUCCESS: 'APP_ACCESS_CONTROL_ACCESS_GRANT_SUCCESS',
    ACCESS_GRANT_FAILURE: 'APP_ACCESS_CONTROL_ACCESS_GRANT_FAILURE',
    DELETE_USER_REQUEST: 'APP_ACCESS_CONTROL_DELETE_USER_REQUEST',
    DELETE_USER_SUCCESS: 'APP_ACCESS_CONTROL_DELETE_USER_SUCCESS',
    DELETE_USER_FAILURE: 'APP_ACCESS_CONTROL_DELETE_USER_FAILURE',
    IMPORT_USERS_REQUEST: 'APP_ACCESS_CONTROL_IMPORT_USERS_REQUEST',
    IMPORT_USERS_SUCCESS: 'APP_ACCESS_CONTROL_IMPORT_USERS_SUCCESS',
    IMPORT_USERS_FAILURE: 'APP_ACCESS_CONTROL_IMPORT_USERS_FAILURE',
    EXPORT_USERS_REQUEST: 'APP_ACCESS_CONTROL_EXPORT_USERS_REQUEST',
    EXPORT_USERS_SUCCESS: 'APP_ACCESS_CONTROL_EXPORT_USERS_SUCCESS',
    EXPORT_USERS_FAILURE: 'APP_ACCESS_CONTROL_EXPORT_USERS_FAILURE',
    DOWNLOAD_SAMPLE_CSV_REQUEST: 'AAC_DOWNLOAD_SAMPLE_CSV_REQUEST',
    DOWNLOAD_SAMPLE_CSV_FAILURE: 'AAC_DOWNLOAD_SAMPLE_CSV_FAILURE',
    DOWNLOAD_SAMPLE_CSV_SUCCESS: 'AAC_DOWNLOAD_SAMPLE_CSV_SUCCESS',
}